import { isEmpty } from "lodash";

/**
 * Generates a color based on the main color with adjustments
 * @param mainColor - The base color in hex format (e.g. "#1fadb2")
 * @param index - Index used to adjust the color
 * @returns A hex color code
 */
export function generateVariantColor(mainColor: string, index: number): string {
  // Parse the hex color to RGB
  const r = parseInt(mainColor.slice(1, 3), 16);
  const g = parseInt(mainColor.slice(3, 5), 16);
  const b = parseInt(mainColor.slice(5, 7), 16);

  // Apply adjustments based on index - shift more toward green/yellow variations
  const adjustedR = Math.min(255, Math.max(0, r + index * 15));
  const adjustedG = Math.min(255, Math.max(0, g + index * 5));
  const adjustedB = Math.min(255, Math.max(0, b - index * 10));

  // Convert back to hex
  return `#${adjustedR.toString(16).padStart(2, "0")}${adjustedG.toString(16).padStart(2, "0")}${adjustedB.toString(16).padStart(2, "0")}`;
}

/**
 * Gets a color based on an identifier
 * @param identifier - The identifier to generate a color for
 * @param mainColor - The base color
 */
export function getColorFromId(
  identifier: string,
  mainColor: string = "#1fadb2",
): string {
  // Use a numeric hash of the identifier to get a consistent index
  const numericId = !isEmpty(identifier)
    ? identifier.split("").reduce((acc, char) => acc + char.charCodeAt(0), 0) %
      10
    : 0;

  return generateVariantColor(mainColor, numericId);
}
